/**
 * Native <select> wrapper styled to match the CRM design system.
 * Replaces Radix Select which has portal/z-index issues.
 *
 * Usage:
 *   <NativeSelect value={val} onChange={setVal} placeholder="Pick one..." options={[
 *     { value: 'a', label: 'Option A' },
 *     { value: 'b', label: 'Option B' },
 *   ]} />
 */
export function NativeSelect({ value, onChange, options = [], placeholder, disabled, className = '', ...props }) {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...props}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
